import axios, { resHandle } from "@/plugins/axios";


/**
 * @description 获取患者列表
 * @param vCom Vue组件
 * @param params 参数
 */
const GetPatientsList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/hospital/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取分中心列表
 * @param vCom Vue组件
 */
const GetHospitals = (vCom: any, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取患者个人信息和健康史
 * @param vCom Vue组件
 */
const GetPatientInfo = (vCom: any, patientId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                patient_id: patientId
            }
        };
        axios.get("api/zwb/patient/info", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取患者某部分信息
 * @param vCom Vue组件
 */
const GetPatientPartDetail = (vCom: any, patientId: string, part: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                patient_id: patientId
            }
        };
        const requestUrl: any = {
            个人信息: "api/zwb/patient/info",
            健康史: "api/zwb/patient/info",
            舌象基础: "api/zwb/patient/tongues",
            舌象科研: "api/zwb/patient/research/tongues",
            舌图报告: "api/zwb/patient/research/tongues2",
            面象数据: "api/zwb/patient/faces",
            脉象数据: "api/zwb/patient/pulses",
            发图数据: "api/zwb/patient/hairs",
            手图数据: "api/zwb/patient/hands",
            中医体质: "api/zwb/patient/nines",
            四诊合参: "api/zwb/patient/tcms",
            儿童版: "api/zwb/patient/chds",
            老年版: "api/zwb/patient/olds",
            备孕女性: "api/zwb/patient/prepres",
            孕期女性: "api/zwb/patient/pres",
            产后女性: "api/zwb/patient/partums",
            围绝经期女性: "api/zwb/patient/wjjqs",
            高血压: "api/zwb/patient/hyps",
            糖尿病: "api/zwb/patient/dias",
            中医心理测评: "api/zwb/patient/phys"
        };
        axios.get(requestUrl[part], params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 服务人次统计概览
 * @param vCom Vue组件
 * @param params 参数
 */
const GetFuwurenci = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(window.GY_ROOT + "openApi/eva/getDoctorsEvaCount", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 服务量统计概览：机构总体情况
 * @param vCom Vue组件
 * @param params 参数
 */
const PostFuwugailanJigouzongti = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/all", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 服务量统计概览：机构月服务趋势图
 * @param vCom Vue组件
 * @param params 参数
 */
const PostFuwugailanYuequshi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/month", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 服务量统计概览：各机构服务量分布状况
 * @param vCom Vue组件
 * @param params 参数
 */
const PostFuwugailanFuwuliangfenbu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/hospital", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 服务量统计概览：重点人群服务量分布状况
 * @param vCom Vue组件
 * @param params 参数
 */
const PostFuwugailanZhongdian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/people", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 服务内容统计：服务内容总体情况
 * @param vCom Vue组件
 * @param params 参数
 */
const PostNeirongZongti = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/tizhis", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 服务内容统计：中医体质情况/中医证型情况
 * @param vCom Vue组件
 * @param params 参数
 */
const PostNeirongTizhi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/tizhi", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 服务内容统计：居民心理类型情况
 * @param vCom Vue组件
 * @param params 参数
 */
const PostNeirongJumin = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/phy", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 人口统计：总体情况/年龄分布/性别分布/地区分布
 * @param vCom Vue组件
 * @param params 参数
 */
const PostRenkou = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/population", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 中医影像导出数据
 * @param vCom Vue组件
 */
const PostDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/export/imgcenter", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 治未病中心导出数据
 * @param vCom Vue组件
 */
const PostHdrDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/export/zwbcenter", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 导出数据表格
 * @param vCom Vue组件
 */
const GetDownloadFile = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/wajue/download", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description [治未病数据中心中心]导出数据页左边添加条件接口：研究指标各个题目信息
 * @param vCom Vue组件
 */
const GetDataExportTopics = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/zwbcenter/search/topics", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description [治未病数据中心]数据导出右边页面接口：研究指标列表
 * @param vCom Vue组件
 */
const GetDataExportTemplates = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/zwbcenter/search/templates").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description [治未病数据中心]患者做过的治未病体质测评列表
 * @param vCom Vue组件
 */
const GetPatientCompletedTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/zwb/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};



export {
    GetPatientsList, GetHospitals, GetPatientInfo, GetPatientPartDetail, PostFuwugailanJigouzongti, PostFuwugailanYuequshi, PostFuwugailanFuwuliangfenbu, PostFuwugailanZhongdian,
    PostNeirongZongti, PostNeirongTizhi, PostNeirongJumin, PostRenkou, PostDataExport, GetDownloadFile, GetDataExportTopics, GetDataExportTemplates, PostHdrDataExport,
    GetPatientCompletedTemplates,
    GetFuwurenci,
};


